import React from 'react'
import LineMoneyBillSlashIcon from 'LuxKit/Icons/line/LineMoneyBillSlashIcon'
import LineSmileIcon from 'LuxKit/Icons/line/LineSmileIcon'
import LineCalendarIcon from 'LuxKit/Icons/line/LineCalendarIcon'
import { formatRoundedAmountWithDollarType } from 'lib/format/formatCurrencyIntl'
import { getHoolahBpMaxLimit } from 'lib/payment/hoolahBpUtils'

export const StepsHowItWorks = [
  {
    image: <LineCalendarIcon size="XL" />,
    title: 'Pay in three instalments.',
    description: 'Pay your first instalment at the time of purchase and the rest in 2 equal monthly instalments.',
  },
  {
    image: <LineMoneyBillSlashIcon size="XL" />,
    title: 'No hidden fees. You only pay what you see.',
    description: 'The only fees are for late payments. But don’t worry, Shopback will send you regular reminders.',
  },
  {
    image: <LineSmileIcon size="XL" />,
    title: 'No minimum spend.',
    description: 'Get what you need, when you need it, without any minimum spend.',
  },
]

export const getStepsBuyNow = (currency: string, regionCode: string) => {
  return [
    {
      title: '1',
      description: 'Browse your favourite escapes.',
    },
    {
      title: '2',
      description: `Choose Shopback as your payment method for purchases ${formatRoundedAmountWithDollarType(getHoolahBpMaxLimit(currency), currency, regionCode)} and under`,
    },
    {
      title: '3',
      description: 'Instantly create an account or login and pay your first instalment when you checkout.',
    },
  ]
}

const urls: Record<string, string> = {
  SGD: 'https://support.shopback.sg/hc/en-us/articles/4843519567891-ShopBack-PayLater-SBPL-Terms-of-Use',
  MYR: 'https://support.shopback.my/hc/en-us/articles/5171311855891-ShopBack-PayLater-SBPL-Terms-of-Use',
  HKD: 'https://www.hoolah.co/hk-en/terms/',
}
export function getTermsAndConditionsUrlLink(currency: string) {
  return urls[currency]
}
